import React from "react";
import _ from "lodash";
import classnames from "classnames";
import { FormattedMessage, injectIntl } from "react-intl";

import Swal from "helpers/swal";
import FilesList from "./FilesList";

import "./style.scss";

const MAX_UPLOAD_SIZE = 10 * 1024 * 1024; // 10MB;

interface IProps {
  input?: any;
  meta?: any;
  label?: string;
  name: string;
  multiple?: boolean;
  containerClassName?: string;
  value?: string | number;
  files?: File[];
  extensions?: string[];
  onChange: (files: File[]) => void;
  remove: (index: number) => void;
  intl: any;
}

interface IState {
  files: File[];
}

class InputFile extends React.Component<IProps, IState> {
  public constructor(props) {
    super(props);

    const files = props.files || [];
    this.state = { files };
  }

  public componentWillReceiveProps(nextProps) {
    const files = nextProps.files || [];
    const currentFiles = this.props.files || [];
    const currentFilesLength =
      _.get(currentFiles, "files.length") || _.get(currentFiles, "length", 0);

    if (files.length !== currentFilesLength) {
      this.setState({ files });
    }
  }

  private handleFileChange = e => {
    const [file] = e.target.files;
    const {
      intl: { formatMessage }
    } = this.props;
    if (file.size > MAX_UPLOAD_SIZE) {
      Swal.alert(formatMessage({ id: "UPLOAD_SIZE_ERROR" }));
      return;
    }

    const { multiple, extensions = [], onChange } = this.props;
    const { name } = file;
    const extension = name.slice(name.lastIndexOf(".") + 1).toLowerCase();

    if (!_.isEmpty(extensions) && !_.includes(extensions, extension)) {
      Swal.alert(
        formatMessage({ id: "UPLOAD_EXTENSION_ERROR" }) + extensions.join(", ")
      );
      return;
    }

    const files = [...(multiple ? this.state.files : []), e.target.files[0]];

    this.setState({ files });
    onChange(files);
  };

  private handleFileRemove = i => {
    this.setState(prevState => ({
      files: prevState.files.filter((file, index) => index !== i)
    }));
    this.props.remove(i);
  };

  public render() {
    const {
      input = {},
      meta = { touched: false, error: null },
      label = "",
      containerClassName = "",
      value = "" as string | number,
      onChange,
      remove,
      files,
      multiple = false,
      ...props
    } = this.props;

    return (
      <div
        className={classnames("fi", containerClassName, {
          error: meta.touched && meta.error
        })}
      >
        {label && <FormattedMessage id={label} tagName="label" />}
        <label className="fi-label">
          <input
            className="fi-input"
            type="file"
            value={value}
            onChange={this.handleFileChange}
            multiple={multiple}
            {...input}
            {...props}
          />
          <p className="fi-fake">
            <FormattedMessage id="INPUT_FILE_CHOOSE" tagName="mark" />
            <FormattedMessage
              id={
                files && files.length ? "INPUT_FILE_SELECTED" : "INPUT_FILE_NO"
              }
              tagName="span"
            />
          </p>
        </label>
        <FilesList
          files={this.state.files}
          removeCallback={this.handleFileRemove}
        />
        {meta.touched && meta.error && <span>{meta.error}</span>}
      </div>
    );
  }
}

export default injectIntl(InputFile);
